const RICH_TEXT_TAG_PATTERN = /<\/?(?:p|strong|em|h2|ol|ul|li|blockquote|a|hr|br)(?:\s|\/?>)/i;

export function looksLikeRichText(text: string): boolean {
    return Boolean(text) && RICH_TEXT_TAG_PATTERN.test(text);
}

function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

export function plainTextToHtml(text: string): string {
    if (!text) {
        return '';
    }
    return text
        .trim()
        .split(/\n\s*\n/)
        .filter((paragraph) => paragraph)
        .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br>')}</p>`)
        .join('');
}

export function toEditorHtml(text: string): string {
    return looksLikeRichText(text) ? text : plainTextToHtml(text);
}

export function richTextToPlainText(text: string): string {
    if (!looksLikeRichText(text)) {
        return text;
    }
    const doc = new DOMParser().parseFromString(text, 'text/html');
    doc.body.querySelectorAll('p, h2, li, blockquote, br').forEach((element) => {
        element.append(' ');
    });
    return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}
